import { Home, User, Search, PlusCircle, ShoppingBag, Shield } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useState } from "react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useMyRoles } from "@/hooks/useMyRoles";
import { preloadPage } from "@/lib/pagePreload";
import BrandLogo from "@/components/BrandLogo";
interface NavigationProps {
  /**
   * Visiteur non connecté sur un lien de partage : au lieu d'ouvrir une page
   * protégée, on rappelle le formulaire d'authentification.
   */
  onRestrictedNavigate?: () => void;
}

const Navigation = ({ onRestrictedNavigate }: NavigationProps = {}) => {
  const location = useLocation();
  const {
    user,
    signOut
  } = useAuth();
  const [darkMode, setDarkMode] = useState(false);
  const { isAdmin, isLoading: isCheckingAdmin } = useMyRoles();
  const toggleDarkMode = (checked: boolean) => {
    setDarkMode(checked);
    document.documentElement.classList.toggle("dark", checked);
  };
  const navItems = [{
    icon: Home,
    label: "Accueil",
    path: "/"
  }, {
    icon: Search,
    label: "Rechercher",
    path: "/search"
  }, {
    icon: PlusCircle,
    label: "Créer",
    path: "/create"
  }, {
    icon: ShoppingBag,
    label: "Boutique",
    path: "/marketplace"
  }, {
    icon: User,
    label: "Profil",
    path: "/profile"
  }];
  // `/feed2` est le banc d'essai du pager : même habillage que l'accueil,
  // sinon la recette comparerait deux thèmes différents.
  const isHomePage = location.pathname === '/';
  return <>
      {/* Navigation - Bottom on mobile and tablet, top on desktop */}
      <nav className={`fixed bottom-0 lg:top-0 lg:bottom-auto left-0 right-0 z-50 bg-background lg:bg-transparent border-t lg:border-t-0 ${location.pathname === '/' ? 'bg-player-background border-player-border lg:border-transparent' : ''}`}>
        <div className="w-full px-4">
        <div className="flex justify-center lg:justify-between items-center h-12 lg:h-16 lg:items-start lg:pt-4">
          <Link to="/" className="hidden lg:flex items-center" aria-label="Accueil TAMA">
            <BrandLogo className="h-7 w-auto" />
          </Link>

          {/* Navigation Icons */}
          <div className="flex items-center justify-between lg:justify-end lg:space-x-2 w-full lg:w-auto lg:ml-auto">
            {navItems.map(item => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              const isRestricted = !!onRestrictedNavigate && item.path !== "/";
              return <Link
                  key={item.path}
                  to={item.path}
                  onPointerEnter={() => preloadPage(item.path)}
                  onTouchStart={() => preloadPage(item.path)}
                  onClick={event => {
                    if (isRestricted) {
                      event.preventDefault();
                      onRestrictedNavigate?.();
                    }
                  }}
                >
                  <Button variant={isActive && !isHomePage ? "default" : "ghost"} size="icon" className={`${isHomePage ? "text-player-foreground hover:text-player-foreground/80" : ""} h-12 w-12 lg:h-10 lg:w-10`}>
                    <Icon className="lg:h-5 lg:w-5 rounded-none h-[36px] w-[36px] shadow-none" />
                  </Button>
                </Link>;
            })}
            {!isCheckingAdmin && isAdmin && <Link to="/admin" className="hidden lg:block">
                <Button variant={location.pathname === "/admin" && !isHomePage ? "default" : "ghost"} size="icon" className={`${isHomePage ? "text-player-foreground hover:text-player-foreground/80" : ""} h-12 w-12 lg:h-10 lg:w-10`}>
                  <Shield className="h-8 w-8 lg:h-5 lg:w-5" />
                </Button>
              </Link>}
            
          </div>
        </div>
        </div>
      </nav>

    </>;
};
export default Navigation;